import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const labelStyle = css`
  margin-bottom: ${theme.spacing(1)};
`;

export const containerStyle = css`
  height: 40px;
  border-radius: ${theme.borderRadius.small};
  color: ${theme.colors.black};
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  margin: ${theme.spacing(0, 0, 2)};
  position: relative;
  transition: outline-color 250ms ease-out;
  outline-color: transparent;
  padding: ${theme.spacing(0, 2)};
  background-color: ${theme.colors.neutral5};
  border: none;
`;
